import styled from "@emotion/styled";
import { css } from "@emotion/react";
import theme from "../../styles/theme";

interface IContentProps {
  isGuttered: boolean;
}

interface IBodyProps {
  isDarkMode: boolean;
  bgOpacity: number;
  scrollPosition: number;
  bgGradient?: boolean;
}

const columns = 12;

const generateColumns = (colCount: number, base?: boolean) => {
  let cols = "";
  for (let x = 1; x <= colCount; x++) {
    cols += `${
      base ? `.` : `&-`
    }col-span-${x} { grid-column: span ${x} / span ${x}; }`;
  }
  return cols;
};

export const GlobalCss = css`
  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

  /* Document
    ========================================================================== */

  /**
   * 1. Correct the line height in all browsers.
   * 2. Prevent adjustments of font size after orientation changes in iOS.
   */

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  /* Sections
    ========================================================================== */

  /**
   * Remove the margin in all browsers.
   */

  body {
    margin: 0;
  }

  /**
   * Render the 'main' element consistently in IE.
   */

  main {
    display: block;
  }

  /**
   * Correct the font size and margin on 'h1' elements within 'section' and
   * 'article' contexts in Chrome, Firefox, and Safari.
   */

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  /* Grouping content
    ========================================================================== */

  /**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd 'em' font sizing in all browsers.
   */

  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /* Text-level semantics
    ========================================================================== */

  /**
   * Remove the gray background on active links in IE 10.
   */

  a {
    background-color: transparent;
  }

  /**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */

  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  /**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */

  b,
  strong {
    font-weight: bolder;
  }

  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd 'em' font sizing in all browsers.
   */

  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /**
   * Add the correct font size in all browsers.
   */

  small {
    font-size: 80%;
  }

  /**
   * Prevent 'sub' and 'sup' elements from affecting the line height in
   * all browsers.
   */

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Embedded content
    ========================================================================== */

  /**
   * Remove the border on images inside links in IE 10.
   */

  img {
    border-style: none;
  }

  /* Forms
    ========================================================================== */

  /**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  /**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
   * Correct the inability to style clickable types in iOS and Safari.
   */

  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }

  /**
   * Remove the inner border and padding in Firefox.
   */

  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
   * Restore the focus styles unset by the previous rule.
   */

  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
   * Correct the padding in Firefox.
   */

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  /**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from 'fieldset' elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    'fieldset' elements in all browsers.
   */

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  /**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */

  progress {
    vertical-align: baseline;
  }

  /**
   * Remove the default vertical scrollbar in IE 10+.
   */

  textarea {
    overflow: auto;
  }

  /**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */

  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  /**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */

  [type="search"] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
   * Remove the inner padding in Chrome and Safari on macOS.
   */

  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to 'inherit' in Safari.
   */

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /* Interactive
    ========================================================================== */

  /*
  * Add the correct display in Edge, IE 10+, and Firefox.
  */

  details {
    display: block;
  }

  /*
  * Add the correct display in all browsers.
  */

  summary {
    display: list-item;
  }

  /* Misc
    ========================================================================== */

  /**
   * Add the correct display in IE 10+.
   */

  template {
    display: none;
  }

  /**
   * Add the correct display in IE 10.
   */

  [hidden] {
    display: none;
  }

  body {
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 20px;
  }

  /*
      NOTE: We are making the base styles on the body available
      as a class here, too. -@criles25
  */
  .lo-base {
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 20px;
  }

  #lo-base {
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 20px;
  }

  html {
    scroll-behavior: smooth;
    // This provides scroll padding - Doesn't work on anchors
    scroll-margin-top: 140px;
    ${theme.largerThan.lg} {
      scroll-margin-top: 180px;
    }
  }

  // this selector add scroll padding to anchor elements
  :target {
    scroll-margin-top: 140px;
    ${theme.largerThan.lg} {
      scroll-margin-top: 180px;
    }
  }

  body {
    margin: 0;
    overflow-x: hidden;
    color: ${theme.colors.darkBlues[100]};
    position: relative;
    line-height: ${theme.leading.normal};
  }
`;

export const FontsCss = css`
  /* cyrillic-ext */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+0460-052F, U+1C80-1C8A, U+20B4, U+2DE0-2DFF, U+A640-A69F,
      U+FE2E-FE2F;
  }
  /* cyrillic */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  /* greek-ext */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtU6FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+1F00-1FFF;
  }
  /* greek */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+0370-0377, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1,
      U+03A3-03FF;
  }
  /* hebrew */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+0307-0308, U+0590-05FF, U+200C-2010, U+20AA, U+25CC,
      U+FB1D-FB4F;
  }
  /* math */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWxU6FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+0302-0303, U+0305, U+0307-0308, U+0310, U+0312, U+0315,
      U+031A, U+0326-0327, U+032C, U+032F-0330, U+0332-0333, U+0338, U+033A,
      U+0346, U+034D, U+0391-03A1, U+03A3-03A9, U+03B1-03C9, U+03D1, U+03D5-03D6,
      U+03F0-03F1, U+03F4-03F5, U+2016-2017, U+2034-2038, U+203C, U+2040, U+2043,
      U+2047, U+2050, U+2057, U+205F, U+2070-2071, U+2074-208E, U+2090-209C,
      U+20D0-20DC, U+20E1, U+20E5-20EF, U+2100-2112, U+2114-2115, U+2117-2121,
      U+2123-214F, U+2190, U+2192, U+2194-21AE, U+21B0-21E5, U+21F1-21F2,
      U+21F4-2211, U+2213-2214, U+2216-22FF, U+2308-230B, U+2310, U+2319,
      U+231C-2321, U+2336-237A, U+237C, U+2395, U+239B-23B7, U+23D0, U+23DC-23E1,
      U+2474-2475, U+25AF, U+25B3, U+25B7, U+25BD, U+25C1, U+25CA, U+25CC,
      U+25FB, U+266D-266F, U+27C0-27FF, U+2900-2AFF, U+2B0E-2B11, U+2B30-2B4C,
      U+2BFE, U+3030, U+FF5B, U+FF5D, U+1D400-1D7FF, U+1EE00-1EEFF;
  }
  /* symbols */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqW106FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+0001-000C, U+000E-001F, U+007F-009F, U+20DD-20E0,
      U+20E2-20E4, U+2150-218F, U+2190, U+2192, U+2194-2199, U+21AF, U+21E6-21F0,
      U+21F3, U+2218-2219, U+2299, U+22C4-22C6, U+2300-243F, U+2440-244A,
      U+2460-24FF, U+25A0-27BF, U+2800-28FF, U+2921-2922, U+2981, U+29BF, U+29EB,
      U+2B00-2BFF, U+4DC0-4DFF, U+FFF9-FFFB, U+10140-1018E, U+10190-1019C,
      U+101A0, U+101D0-101FD, U+102E0-102FB, U+10E60-10E7E, U+1D2C0-1D2D3,
      U+1D2E0-1D37F, U+1F000-1F0FF, U+1F100-1F1AD, U+1F1E6-1F1FF, U+1F30D-1F30F,
      U+1F315, U+1F31C, U+1F31E, U+1F320-1F32C, U+1F336, U+1F378, U+1F37D,
      U+1F382, U+1F393-1F39F, U+1F3A7-1F3A8, U+1F3AC-1F3AF, U+1F3C2,
      U+1F3C4-1F3C6, U+1F3CA-1F3CE, U+1F3D4-1F3E0, U+1F3ED, U+1F3F1-1F3F3,
      U+1F3F5-1F3F7, U+1F408, U+1F415, U+1F41F, U+1F426, U+1F43F, U+1F441-1F442,
      U+1F444, U+1F446-1F449, U+1F44C-1F44E, U+1F453, U+1F46A, U+1F47D, U+1F4A3,
      U+1F4B0, U+1F4B3, U+1F4B9, U+1F4BB, U+1F4BF, U+1F4C8-1F4CB, U+1F4D6,
      U+1F4DA, U+1F4DF, U+1F4E3-1F4E6, U+1F4EA-1F4ED, U+1F4F7, U+1F4F9-1F4FB,
      U+1F4FD-1F4FE, U+1F503, U+1F507-1F50B, U+1F50D, U+1F512-1F513,
      U+1F53E-1F54A, U+1F54F-1F5FA, U+1F610, U+1F650-1F67F, U+1F687, U+1F68D,
      U+1F691, U+1F694, U+1F698, U+1F6AD, U+1F6B2, U+1F6B9-1F6BA, U+1F6BC,
      U+1F6C6-1F6CF, U+1F6D3-1F6D7, U+1F6E0-1F6EA, U+1F6F0-1F6F3, U+1F6F7-1F6FC,
      U+1F700-1F7FF, U+1F800-1F80B, U+1F810-1F847, U+1F850-1F859, U+1F860-1F887,
      U+1F890-1F8AD, U+1F8B0-1F8BB, U+1F8C0-1F8C1, U+1F900-1F90B, U+1F93B,
      U+1F946, U+1F984, U+1F996, U+1F9E9, U+1FA00-1FA6F, U+1FA70-1FA7C,
      U+1FA80-1FA89, U+1FA8F-1FAC6, U+1FACE-1FADC, U+1FADF-1FAE9, U+1FAF0-1FAF8,
      U+1FB00-1FBFF;
  }
  /* vietnamese */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169,
      U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
      U+0329, U+1EA0-1EF9, U+20AB;
  }
  /* latin-ext */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06FxZCJgvAQ.woff2)
      format("woff2");
    unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7,
      U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF,
      U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6FxZCJgg.woff2)
      format("woff2");
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191,
      U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  /* cyrillic-ext */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+0460-052F, U+1C80-1C8A, U+20B4, U+2DE0-2DFF, U+A640-A69F,
      U+FE2E-FE2F;
  }
  /* cyrillic */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  /* greek-ext */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+1F00-1FFF;
  }
  /* greek */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+0370-0377, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1,
      U+03A3-03FF;
  }
  /* hebrew */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+0307-0308, U+0590-05FF, U+200C-2010, U+20AA, U+25CC,
      U+FB1D-FB4F;
  }
  /* math */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTVOmu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+0302-0303, U+0305, U+0307-0308, U+0310, U+0312, U+0315,
      U+031A, U+0326-0327, U+032C, U+032F-0330, U+0332-0333, U+0338, U+033A,
      U+0346, U+034D, U+0391-03A1, U+03A3-03A9, U+03B1-03C9, U+03D1, U+03D5-03D6,
      U+03F0-03F1, U+03F4-03F5, U+2016-2017, U+2034-2038, U+203C, U+2040, U+2043,
      U+2047, U+2050, U+2057, U+205F, U+2070-2071, U+2074-208E, U+2090-209C,
      U+20D0-20DC, U+20E1, U+20E5-20EF, U+2100-2112, U+2114-2115, U+2117-2121,
      U+2123-214F, U+2190, U+2192, U+2194-21AE, U+21B0-21E5, U+21F1-21F2,
      U+21F4-2211, U+2213-2214, U+2216-22FF, U+2308-230B, U+2310, U+2319,
      U+231C-2321, U+2336-237A, U+237C, U+2395, U+239B-23B7, U+23D0, U+23DC-23E1,
      U+2474-2475, U+25AF, U+25B3, U+25B7, U+25BD, U+25C1, U+25CA, U+25CC,
      U+25FB, U+266D-266F, U+27C0-27FF, U+2900-2AFF, U+2B0E-2B11, U+2B30-2B4C,
      U+2BFE, U+3030, U+FF5B, U+FF5D, U+1D400-1D7FF, U+1EE00-1EEFF;
  }
  /* symbols */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTUGmu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+0001-000C, U+000E-001F, U+007F-009F, U+20DD-20E0,
      U+20E2-20E4, U+2150-218F, U+2190, U+2192, U+2194-2199, U+21AF, U+21E6-21F0,
      U+21F3, U+2218-2219, U+2299, U+22C4-22C6, U+2300-243F, U+2440-244A,
      U+2460-24FF, U+25A0-27BF, U+2800-28FF, U+2921-2922, U+2981, U+29BF, U+29EB,
      U+2B00-2BFF, U+4DC0-4DFF, U+FFF9-FFFB, U+10140-1018E, U+10190-1019C,
      U+101A0, U+101D0-101FD, U+102E0-102FB, U+10E60-10E7E, U+1D2C0-1D2D3,
      U+1D2E0-1D37F, U+1F000-1F0FF, U+1F100-1F1AD, U+1F1E6-1F1FF, U+1F30D-1F30F,
      U+1F315, U+1F31C, U+1F31E, U+1F320-1F32C, U+1F336, U+1F378, U+1F37D,
      U+1F382, U+1F393-1F39F, U+1F3A7-1F3A8, U+1F3AC-1F3AF, U+1F3C2,
      U+1F3C4-1F3C6, U+1F3CA-1F3CE, U+1F3D4-1F3E0, U+1F3ED, U+1F3F1-1F3F3,
      U+1F3F5-1F3F7, U+1F408, U+1F415, U+1F41F, U+1F426, U+1F43F, U+1F441-1F442,
      U+1F444, U+1F446-1F449, U+1F44C-1F44E, U+1F453, U+1F46A, U+1F47D, U+1F4A3,
      U+1F4B0, U+1F4B3, U+1F4B9, U+1F4BB, U+1F4BF, U+1F4C8-1F4CB, U+1F4D6,
      U+1F4DA, U+1F4DF, U+1F4E3-1F4E6, U+1F4EA-1F4ED, U+1F4F7, U+1F4F9-1F4FB,
      U+1F4FD-1F4FE, U+1F503, U+1F507-1F50B, U+1F50D, U+1F512-1F513,
      U+1F53E-1F54A, U+1F54F-1F5FA, U+1F610, U+1F650-1F67F, U+1F687, U+1F68D,
      U+1F691, U+1F694, U+1F698, U+1F6AD, U+1F6B2, U+1F6B9-1F6BA, U+1F6BC,
      U+1F6C6-1F6CF, U+1F6D3-1F6D7, U+1F6E0-1F6EA, U+1F6F0-1F6F3, U+1F6F7-1F6FC,
      U+1F700-1F7FF, U+1F800-1F80B, U+1F810-1F847, U+1F850-1F859, U+1F860-1F887,
      U+1F890-1F8AD, U+1F8B0-1F8BB, U+1F8C0-1F8C1, U+1F900-1F90B, U+1F93B,
      U+1F946, U+1F984, U+1F996, U+1F9E9, U+1FA00-1FA6F, U+1FA70-1FA7C,
      U+1FA80-1FA89, U+1FA8F-1FAC6, U+1FACE-1FADC, U+1FADF-1FAE9, U+1FAF0-1FAF8,
      U+1FB00-1FBFF;
  }
  /* vietnamese */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169,
      U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
      U+0329, U+1EA0-1EF9, U+20AB;
  }
  /* latin-ext */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu0SC55K5gw.woff2)
      format("woff2");
    unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7,
      U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF,
      U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300 800;
    font-stretch: 100%;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/opensans/v40/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2)
      format("woff2");
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191,
      U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
`;

export const Body = styled.div<IBodyProps>`
  transition: background ease-in 500ms;
  background: ${(props) =>
    props.bgGradient
      ? `linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.9) 0,
    rgba(223, 236, 253, 1) 10%,
    rgba(255, 255, 255, 0.9) 20%
  );`
      : theme.colors.white};

  &:before {
    content: "";
    display: block;
    position: absolute;
    z-index: ${(props) => (props.isDarkMode && props.bgOpacity >= 1 ? 0 : -1)};
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      rgba(9, 44, 71, 1) 200px,
      rgba(34, 68, 95, 1) 8%,
      rgba(255, 255, 255, 0) 30%
    );
    transition: opacity ease-out 250ms;
    opacity: ${(props) => (props.isDarkMode ? props.bgOpacity : "0")};
  }

  &:after {
    content: "";
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    backdrop-filter: blur(6px);
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 10;
  }

  // Reusable Content
  .icons {
    margin: 0 auto;
    padding: 0;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${theme.spacing[4]};
    align-content: flex-start;
    max-width: ${theme.narrowWidth};

    ${theme.largerThan.lg} {
      flex-direction: row;
      gap: ${theme.spacing[8]};
    }

    li {
      grid-column: span 1 / span 1;
      display: flex;
      gap: ${theme.spacing[4]};
      align-items: flex-start;
      justify-content: flex-start;
      font-size: ${theme.fontSizes[2]};

      .gatsby-image-wrapper {
        max-height: 20px;
        max-width: 20px;
      }

      span {
        max-width: 250px;
      }
    }
  }

  .quoting-steps {
    margin: 0 auto;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing[4]};
    max-width: ${theme.maxWidth};

    ${theme.largerThan.md} {
      margin: ${theme.spacing[4]} auto;
      gap: ${theme.spacing[8]};
    }

    ${theme.largerThan.lg} {
      margin: ${theme.spacing[8]} auto;
      gap: ${theme.spacing[24]};
    }

    li {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing[2]};
      width: 100px;
      text-align: center;
      transition: all 0.1s ease-in;

      &:hover {
        transform: scale(1.02);
      }

      ${theme.largerThan.md} {
        width: 150px;
      }

      ${theme.largerThan.lg} {
        width: 200px;
      }

      .gatsby-image-wrapper {
        background-color: ${theme.colors.white};
        width: 100px;
        height: 100px;
        border-radius: 100px;

        &:hover {
          outline-style: solid;
          outline-color: #f8fafc;
        }

        ${theme.largerThan.md} {
          width: 150px;
          height: 150px;
        }

        ${theme.largerThan.lg} {
          width: 200px;
          height: 200px;
        }

        picture {
          width: 75px;
          height: 75px;

          ${theme.largerThan.md} {
            width: 125px;
            height: 125px;
          }

          ${theme.largerThan.lg} {
            width: 150px;
            height: 150px;
          }
        }

        img {
          object-fit: contain !important;
          width: 75px;
          height: 75px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          ${theme.largerThan.md} {
            width: 125px;
            height: 125px;
          }

          ${theme.largerThan.lg} {
            width: 150px;
            height: 150px;
          }
        }
      }

      h6 {
        font-size: ${theme.fontSizes[0]};
        font-weight: ${theme.fontWeights.semibold};

        ${theme.largerThan.md} {
          font-size: ${theme.fontSizes[1]};
        }
      }
    }
  }

  .company-logos {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[2]};

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      gap: ${theme.spacing[8]};
      align-items: center;

      li {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;

        img {
          max-height: 30px;

          ${theme.largerThan.md} {
            max-height: 50px;
          }
        }
      }
    }

    h6 {
      ${theme.text.xs};
      text-transform: uppercase;
      color: ${theme.colors.darkBlues[75]};
      text-align: center;
      margin: ${theme.spacing[4]} 0 0 0;
    }

    &.company-logos-left {
      display: inline-block;

      img {
        opacity: 0.8;
      }

      h6 {
        text-align: left;
      }
    }
  }

  .trustpilot-widget {
    width: max-content;

    ${theme.largerThan.md} {
      width: 420px;
    }

    ${theme.largerThan.xl} {
      justify-self: end;
    }
  }
`;

export const GridCss = css`
  // grid system
  .grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: ${theme.spacing[4]};
    box-sizing: border-box;

    * {
      box-sizing: border-box;
    }

    ${theme.largerThan.md} {
      grid-template-columns: repeat(8, minmax(0, 1fr));
      gap: ${theme.spacing[8]};
    }

    ${theme.largerThan.lg} {
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }

    .side-col {
      padding: 0 ${theme.spacing[4]};
      grid-column: span 4 / span 4;
      position: sticky;
      top: 62px;
      z-index: 20;
      padding-bottom: ${theme.spacing["2"]};
      background-color: ${theme.colors.white};

      ${theme.largerThan.md} {
        grid-column: span 8 / span 8;
        top: 62px;
      }

      ${theme.largerThan.lg} {
        padding: 0;
        grid-column: span 3 / span 3;
        posiiton: static;
        top: auto;
        background-color: transparent;
      }
    }

    .main-col {
      grid-column: span 4 / span 4;

      ${theme.largerThan.md} {
        grid-column: span 8 / span 8;
      }

      ${theme.largerThan.lg} {
        grid-column: span 9 / span 9;
      }

      // no top margin for first slice
      > div:first-of-type > div {
        margin-top: 0;
      }
    }

    .main-col [class*="full-width-cta"] {
      margin: ${theme.spacing[8]} ${theme.spacing[4]};
      padding-left: ${theme.spacing[4]};
      padding-right: ${theme.spacing[4]};
      border-radius: ${theme.borderRadius};

      ${theme.largerThan.lg} {
        margin: ${theme.spacing[8]} auto;
        padding-left: ${theme.spacing[8]};
        padding-right: ${theme.spacing[8]};
      }
    }

    .main-col-full {
      grid-column: span 4 / span 4;

      ${theme.largerThan.md} {
        grid-column: span 8 / span 8;
      }

      ${theme.largerThan.lg} {
        grid-column: span 12 / span 12;
      }
    }
  }

  ${generateColumns(4, true)}

  .md {
    ${theme.largerThan.md} {
      ${generateColumns(8)}
    }
  }

  .lg {
    ${theme.largerThan.lg} {
      ${generateColumns(12)}
    }
  }

  .xl {
    ${theme.largerThan.xl} {
      ${generateColumns(12)}
    }
  }

  .content-center {
    align-content: center;
  }
`;

export const SectionsCss = css`
  // global slice section styling to improve consistency
  .slice-section {
    padding: ${theme.spacing[8]} ${theme.spacing[4]};

    ${theme.largerThan.md} {
      padding: ${theme.spacing[16]} ${theme.spacing[4]};
    }

    &.tight {
      padding: ${theme.spacing[4]} ${theme.spacing[4]};
    }
  }

  .main-col {
    .slice-section {
      padding: ${theme.spacing[4]};

      ${theme.largerThan.lg} {
        padding: ${theme.spacing[8]} 0;
      }
    }

    .container {
      margin: 0;
    }
  }

  .container {
    max-width: ${theme.maxWidth};
    margin: 0 auto;

    &.narrow {
      max-width: ${theme.narrowWidth};
    }

    ${theme.largerThan.md} {
      margin: 0 auto;
    }

    ${theme.largerThan.xl} {
      margin: 0 auto;
    }
  }
`;

export const TypographyCss = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${theme.colors.darkBlues[100]};
    font-weight: ${theme.fontWeights.regular};
  }

  h1 {
    font-size: ${theme.fontSizes[5]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.leading.tight};
    margin: 0 0 ${theme.spacing[4]} 0;

    ${theme.largerThan.lg} {
      font-size: ${theme.fontSizes[7]};
      line-height: ${theme.leading.tight};
    }
  }

  h2 {
    font-size: ${theme.fontSizes[4]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.leading.tight};
    margin: 0 0 ${theme.spacing[4]} 0;

    ${theme.largerThan.lg} {
      ${theme.text["4xl"]}
      margin: 0 0 ${theme.spacing[8]} 0;
    }
  }

  header {
    h2 {
      margin-top: 0;
    }

    h2:after {
      content: "";
      display: block;
      width: ${theme.spacing[16]};
      height: ${theme.spacing[0.5]};
      margin-top: ${theme.spacing[4]};
      background-color: ${theme.colors.darkGreen};

      ${theme.largerThan.lg} {
        margin-top: ${theme.spacing[8]};
      }
    }

    p {
      font-size: ${theme.fontSizes[2]};
    }
  }

  h3 {
    font-size: ${theme.fontSizes[3]};
    line-height: ${theme.leading.snug};
    margin: 0 0 ${theme.spacing[2]} 0;

    ${theme.largerThan.lg} {
      font-size: ${theme.fontSizes[5]};
      line-height: ${theme.leading.snug};
    }
  }

  h4 {
    font-size: ${theme.fontSizes[2]};
    line-height: ${theme.leading.snug};
    margin: 0 0 ${theme.spacing[2]} 0;

    ${theme.largerThan.lg} {
      font-size: ${theme.fontSizes[4]};
      line-height: ${theme.leading.snug};
    }
  }

  h5 {
    font-size: ${theme.fontSizes[1]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.leading.snug};
    margin: 0 0 ${theme.spacing[2]} 0;
    text-transform: uppercase;

    ${theme.largerThan.lg} {
      font-size: ${theme.fontSizes[3]};
      line-height: ${theme.leading.snug};
    }
  }

  h6 {
    font-size: ${theme.fontSizes[2]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.leading.snug};
    text-transform: uppercase;
    margin: 0;
  }

  // Font Weights
  .font-light {
    font-weight: ${theme.fontWeights.light};
  }

  .font-regular {
    font-weight: ${theme.fontWeights.regular};
  }

  .font-semibold {
    font-weight: ${theme.fontWeights.semibold};
  }

  .font-bold {
    font-weight: ${theme.fontWeights.bold};
  }

  // Text Decoration
  .underline {
    text-decoration-line: underline;
  }

  .no-underline {
    text-decoration-line: none;
  }

  // In an effort to reduce static file size, I will be developing reusable classes.
  // Will find a better place for these styles.
  .intro {
    font-size: ${theme.fontSizes[2]};
    line-height: ${theme.leading.normal};
    color: ${theme.colors.darkBlues[75]};

    ${theme.largerThan.lg} {
      font-size: ${theme.fontSizes[3]};
      line-height: ${theme.leading.relaxed};
    }
  }

  .intro-lg {
    ${theme.text.xl};

    ${theme.largerThan.lg} {
      ${theme.text["2xl"]};
    }

    ${theme.largerThan.xl} {
      ${theme.text["3xl"]};
    }
  }

  .intro-2xl {
    ${theme.text["2xl"]};

    ${theme.largerThan.lg} {
      ${theme.text["2xl"]};
    }

    ${theme.largerThan.xl} {
      ${theme.text["3xl"]};
    }
  }

  .uppercase {
    text-transform: uppercase;
  }

  .text-center {
    text-align: center;
  }

  // List Style Type
  .list-none {
    list-style-type: none;
  }
`;

export const SpacingCss = css`
  .p-0 {
    padding: 0px;
  }

  .m-0 {
    margin: 0px;
  }
`;

export const ColorsCss = css`
  // Text Color
  .text-white {
    color: ${theme.colors.white};
  }

  .text-xom-blue-100 {
    color: ${theme.colors.blues[100]};
  }

  .text-xom-dark-75 {
    color: ${theme.colors.darkBlues[75]};
  }

  .bg-yellow {
    background: ${theme.colors.yellow};
  }

  .bg-green {
    background: ${theme.colors.greens[100]};
  }

  a.link {
    color: ${theme.colors.blues[100]};

    &.link-white {
      color: ${theme.colors.white};
      text-decoration: underline;
    }
  }

  a.button {
    display: inline-block;

    &.button-green {
      background-color: ${theme.colors.greens[100]};
      color: ${theme.colors.white};
    }
    &.button-yellow {
      background-color: ${theme.colors.yellows[100]};
      color: ${theme.colors.black};
    }
  }
`;

export const ThemeCss = css`
  .theme-light-blue {
    background-color: ${theme.colors.blues[10]};
  }
`;

export const UtilityCss = css`
  .hidden {
    display: none;
  }

  .overflow-hidden {
    overflow: hidden;
  }

  .relative {
    position: relative;
  }
`;

export const SlickCarouselCss = css`
  .slick-dots {
    margin-top: ${theme.spacing[8]};

    li {
      button {
        &:before {
          font-size: ${theme.spacing[3]} !important;
        }
      }

      &.slick-active {
        button {
          &:before {
            color: ${theme.colors.blues[100]} !important;
            opacity: 1 !important;
          }
        }
      }
    }
  }
`;

export const ContentBackground = styled.div`
  width: 100%;
  height: 100%;
`;

export const SimpleContentBackground = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
`;

export const HeaderBase = styled.div<IBodyProps>`
  width: 100%;
  z-index: 8888;
  top: 0;
  transition: all ease-out 0.5s;
  position: sticky;
  // ${(props) =>
    props.scrollPosition > 100 &&
    `transform: translateY(${props.scrollPosition}px)`};
`;

export const Content = styled.main<IContentProps>`
  ${(props) => {
    if (props.isGuttered)
      return `
      max-width: ${theme.maxWidth};
      padding: 2.8125rem 1.0875rem;
    `;
  }}

  margin: 0 auto;
`;
